<template>
    <div class="budget-summary">
        <b-row>
            <b-col cols="12" class="budget-section-header">
                <span class="budget-section-header-title">Perkins Funding Totals</span>
                <div class="header-separator" />
            </b-col>
        </b-row>
        <b-row class="ml-1">
            <b-col cols="12" sm="4">
                <b-row>
                    <b-col
                        v-b-tooltip.hover
                        cols="auto"
                        class="title-display-label"
                        title="Amount of Perkins Funds Awarded"
                    >
                        Awarded:
                    </b-col>
                    <b-col
                        cols="5"
                        sm="11"
                        md="auto"
                        offset-sm="1"
                        offset-md="0"
                        class="title-display-content"
                    >
                        {{ perkinsFundsAwarded.toCurrency() }}
                    </b-col>
                </b-row>
            </b-col>
            <!-- <b-col cols="12" sm="4">
                <b-row>
                    <b-col
                        v-b-tooltip.hover
                        cols="auto"
                        class="title-display-label"
                        title="Sum of all Activity Cost entries"
                    >
                        Budgeted:
                    </b-col>
                    <b-col
                        cols="5"
                        sm="11"
                        md="auto"
                        offset-sm="1"
                        offset-md="0"
                        class="title-display-content"
                    >
                        {{ perkinsFundsBudgeted.toCurrency() }}
                    </b-col>
                </b-row>
            </b-col> -->
            <b-col cols="12" sm="4">
                <b-row>
                    <b-col
                        v-b-tooltip.hover
                        cols="auto"
                        class="title-display-label"
                        title="Awarded minus Budgeted
                        plus remainders of Approved and Fully Purchased Costs"
                    >
                        Unallocated:
                    </b-col>
                    <b-col
                        cols="5"
                        sm="11"
                        md="auto"
                        offset-sm="1"
                        offset-md="0"
                        class="title-display-content"
                    >
                        {{ perkinsFundsAvailable.toCurrency() }}
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'BudgetSummary',

    data() {
        return {};
    },

    computed: {
        ...mapGetters({
            perkinsFundsAwarded: 'cost/perkinsFundsAwarded',
            // perkinsFundsBudgeted: 'cost/perkinsFundsBudgeted',
            perkinsFundsAvailable: 'cost/perkinsFundsAvailable',

        }),
    },
};
</script>

<style scoped lang="scss">
.title-display-label {
    font-weight: normal;
    text-align: right;
    padding-right: 0;
}

.title-display-content {
    font-weight: bold;
    text-align: left;
    padding-left: 0.75rem;
}

.budget-summary {
    .budget-section-header {
        margin: 1em 0 0 0;
        display: flex;

        .budget-section-header-title {
            font-size: 1.05em;
            font-weight: 100;
            padding: 0 0.5em 0 0;
        }

        .header-separator {
            border-bottom: #5a6268 solid 1px;
            margin: -0.75em 2em 0.75em 0;
            min-height: 1px;
            flex: 1 1 auto;
        }
    }

    :first-child {
        .budget-section-header {
            margin: 0 0 0 0;
        }
    }

    .budget-summary-item {
        display: flex;
    }
}
</style>
